import { FormatDate } from '../../utils/formatDate';
import { Box, Typography } from '@mui/material';
import Skeleton from '@mui/material/Skeleton';
import Iconify from '../Iconify';

const InvoicesListViewData = ({ invoice, handleInvoiceClick, columnWidth }) => {

    if (!invoice) {
        return (
            <Box className='table_row'>
                <Box className='tableBodyCell' sx={{ color: '#EA5E00', minWidth: columnWidth.date, position: 'sticky', left: 0, backgroundColor: 'white', zIndex: 1 }}><Skeleton variant="text" width="100%" /></Box>
                <Box sx={{ color: '#414040', minWidth: columnWidth.invoice_number }}><Skeleton variant="text" width="100%" /></Box>
                <Box sx={{ color: '#414040', minWidth: columnWidth.company }}><Skeleton variant="text" width="100%" /></Box>
                <Box sx={{ color: '#414040', minWidth: columnWidth.machines }}><Skeleton variant="text" width="100%" /></Box>
                <Box sx={{ color: '#414040', minWidth: columnWidth.amount }}><Skeleton variant="text" width="100%" /></Box>
                <Box sx={{ color: '#414040', minWidth: columnWidth.documents }}><Skeleton variant="text" width="100%" /></Box>
                <Box sx={{ color: '#EA5E00', width: '50px' }}><Iconify icon={'ri:arrow-right-s-line'} /></Box>
            </Box>
        );
    }

    return (
        <Box className='table_row' onClick={() => handleInvoiceClick(invoice.id)}>
            <Box className='tableBodyCell' sx={{ color: '#EA5E00', minWidth: columnWidth.date, maxWidth: columnWidth.date, position: 'sticky', left: 0, backgroundColor: 'white', zIndex: 1 }}>
                <Typography className='tableBodyTypography'>{FormatDate(invoice?.date)}</Typography>
            </Box>
            <Box className='tableBodyCell' sx={{ color: '#414040', minWidth: columnWidth.invoice_number, maxWidth: columnWidth.invoice_number }}>
                <Typography className='tableBodyTypography'>  {invoice?.invoice_number || 'N/A'}</Typography>
            </Box>
            <Box className='tableBodyCell' sx={{ color: '#414040', minWidth: columnWidth.company, maxWidth: columnWidth.company }}>
                <Typography className='tableBodyTypography'> {invoice?.company.name}</Typography>
            </Box>
            <Box className='tableBodyCell' sx={{ color: '#414040', minWidth: columnWidth.machines, maxWidth: columnWidth.machines }}>
                {invoice?.invoice_machine?.length === 0 ?
                    <Typography className='tableBodyTypography'>N/A</Typography>
                    :
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                        <Typography className='tableBodyTypography'>{invoice?.invoice_machine?.[0]?.machine?.name}</Typography>
                        {invoice?.invoice_machine?.length > 1 && (
                            <Typography className='machines_gridview_machine_metier_length' component="span">+{invoice?.invoice_machine?.length - 1}</Typography>
                        )}
                    </Box>
                }
            </Box>
            <Box className='tableBodyCell' sx={{ color: '#414040', minWidth: columnWidth.amount, maxWidth: columnWidth.amount }}>
                <Typography className='tableBodyTypography'>{invoice?.amount ? new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'EUR' }).format(invoice?.amount) : '0,00 €'} </Typography>
            </Box>
            <Box className='tableBodyCell' sx={{ color: '#414040', minWidth: columnWidth.documents, maxWidth: columnWidth.documents }}>
                <Typography className='tableBodyTypography'>
                    {Array.isArray(invoice.invoice_document) && invoice?.invoice_document?.length > 1
                        ? `${invoice.invoice_document.length} PDFs`
                        : `${invoice.invoice_document.length} PDF`}
                </Typography>
            </Box>
            <Box className='tableBodyCell' sx={{ color: '#EA5E00', minWidth: '50px' }}><Iconify icon={'ri:arrow-right-s-line'} /></Box>
        </Box>
    );
};

export default InvoicesListViewData;